import { render, staticRenderFns } from "./price-panel.vue?vue&type=template&id=4577760a&scoped=true"
import script from "./price-panel.vue?vue&type=script&lang=js"
export * from "./price-panel.vue?vue&type=script&lang=js"
import style0 from "./price-panel.vue?vue&type=style&index=0&id=4577760a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577760a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4577760a')) {
      api.createRecord('4577760a', component.options)
    } else {
      api.reload('4577760a', component.options)
    }
    module.hot.accept("./price-panel.vue?vue&type=template&id=4577760a&scoped=true", function () {
      api.rerender('4577760a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/units/components/price/price-panel.vue"
export default component.exports